//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import productCardMixin from '@motionelements/core/src/components/mixins/product-card.mixin.js';

export default {
  name: 'product-card',
  components: {
    ProductCardPreview: () => import('@motionelements/core/src/components/product-card/sections/ProductCardPreview.vue'),
    TopBar: () => import('./sections/top-bar/ProductCardTopBar.vue'),
    Actions: () => import('./sections/ProductCardActions.vue'),
    Info: () => import('./sections/ProductCardMediaTypeInfo.vue'),
    MoreInfo: () => import('./sections/ProductCardMoreInfo.vue'),
    ProductCardStatus: () => import('@motionelements/core/src/components/product-card/sections/ProductCardStatus.vue'),
  },
  mixins: [productCardMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    // Badge
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    showRemove: {
      type: Boolean,
      default: false,
    },
    showBadges: {
      type: Boolean,
      default: false,
    },
    // Info
    showProductIcon: {
      type: Boolean,
      default: true,
    },
    showPro: {
      type: Boolean,
      default: true,
    },
    // Actions
    showActions: {
      type: Boolean,
      default: true,
    },
    showFavorite: {
      type: Boolean,
      default: true,
    },
    showPin: {
      type: Boolean,
      default: false,
    },
    showSimilar: {
      type: Boolean,
      default: true,
    },
    showDownloadSample: {
      type: Boolean,
      default: true,
    },
    showView: {
      type: Boolean,
      default: true,
    },

    // More Info
    showName: {
      type: Boolean,
      default: false,
    },
    showCategory: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    // patch topbar cannot draggble on chrome
    draggable: {
      type: Boolean,
      default: false,
    },
    // storing other metadata, e.g. for tracking
    metadata: {
      type: Object,
    },

    showTopBarActions: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHovering: false,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    ...mapGetters({
      currentProduct: 'product/currentElement',
    }),
    isElement() {
      return _.get(this.product, 'object') === 'element';
    },
    isCollection() {
      return _.get(this.product, 'object') === 'collection';
    },
    searchQueryId() {
      return _.get(this.metadata, 'queryId');
    },
    linkUrl() {
      let url = _.get(this.options, 'linkUrl') || _.get(this.product, 'html.url'); // @toDo @Steve what is this.options?

      // add in query_id / position for tracking
      if (this.searchQueryId) {
        url += `?query_id=${this.metadata.queryId}`;
        if (_.get(this.metadata, 'position')) {
          url += `&position=${this.metadata.position}`;
        }
      }

      return url;
    },
    mediaType() {
      return _.get(this.product, 'mediaType');
    },
    isAudio() {
      return isProductType('audio', this.mediaType);
    },
    showBar() {
      return this.showBadges || this.showCheckbox || this.showRemove;
    },
    showMoreInfo() {
      return this.showName || this.showCategory || this.showPrice;
    },
    collectionItemCount() {
      return this.isCollection ? _.get(this.product, 'items.totalCount') : null;
    },
    // eventData() {
    //   // inject metadata into emit data
    //   // e.g. queryId, position
    //   return { ...this.product, ...{ metadata: this.metadata } };
    // },
  },
  methods: {
    onPreviewed() {
      // console.log('product-previewed', event);
      this.emitProductEvent('product-previewed');
      // this.$bus.$emit('product-previewed', this.eventData);
    },
    onClickActionButton(action) {
      switch (action) {
        case 'view':
          this.onClickProduct();
          break;
        case 'similar':
          this.emitProductEvent('product-similar-search');
          // this.$bus.$emit('filter-similar', this.product); // send event to mixins product-events
          // this.$bus.$emit('product-similar-search', this.eventData); // send event to mixins product-events
          // this.$bus.$emit('product-similar-searched', this.eventData); // for teleport tracking
          break;
        case 'favorite':
          this.emitProductEvent('product-favorite');
          // this.$bus.$emit('product-favorited', this.eventData); // send event to mixins product-events
          break;
        case 'unfavorited':
          this.emitProductEvent('product-unfavorited');
          break;
        case 'pin':
          this.emitProductEvent('product-pin');
          break;
        case 'sample-download':
          this.emitProductEvent('product-sample-download');
          // this.$bus.$emit('product-sample-download', this.eventData); // send event to mixins product-events
          // this.onDownloadSample();
          break;
        case 'download':
          this.emitProductEvent('download');
          break;
        default:
      }
    },
    emitProductEvent(eventName) {
      this.$emit(eventName);
      this.$bus.$emit(eventName, {
        product: {
          ...this.product,
          ...{ metadata: this.metadata },
        },
      }); // send event to mixins product-events
    },
    onClickMoreInfo(action) {
      switch (action) {
        case 'view':
          this.onClickProduct();
          break;
        case 'category':
          break;
        default:
      }
    },
    onClickProduct() {
      this.emitProductEvent('product-selected');
    },
    // onDownloadSample() {
    //   if (!this.isLoggedIn) {
    //     this.$store.dispatch('modal/showSignUp');
    //     return;
    //   }
    //   // @todo change to use url from API: /v2/elements/:sku/download-sample
    //   // console.log('product-download-preview', this.$link(`/download/sample/${this.product.id}`).url());
    //   window.location.href = this.$link(`/download/sample/${this.product.id}`).url();
    //   this.$bus.$emit('product-sample-downloaded', this.eventData); // for teleport tracking
    // },
    viewProduct(event) {
      if (this.product.id === _.get(this.currentProduct, 'id')) {
        console.log('product is already viewed');
      } else {
        this.redirectToProductPage(event, this.product);
      }
    },
  },
};
